export default __webpack_public_path__ + "static/media/esg-leadership-summit-2023.9e32911c.jpg";